import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiFormReportListComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-list/fi-form-report-list.component';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiFormReportContainerComponent } from '@fi-app/fi-form/fi-form-report/fi-form-report-container.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';

const FormReportRootState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Report._name,
    url: '/Reports',
    component: FiAbstractStateComponent,
};

const FormReportState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Report.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: FiFormReportListComponent,
    reloadOnSearch: false,
};

const FormReportViewState: Ng2StateDeclaration = {
    name: FiStateNames.Form.Report.View,
    url: '/View/{id:[0-9]+}?{pos}',
    reloadOnSearch: false,
    views: {
        '@Module': {
            component: FiFormReportContainerComponent,
        },
    },
    resolve: {
        formReport: [FiFormService, FiStateService, Transition, FormReportViewFormReport],
    },
};

export function FormReportViewFormReport(
    formService: FiFormService,
    stateService: FiStateService,
    transition: Transition,
) {
    return formService.getFormReport(stateService.getParams(transition).id);
}

export const FormReportStates: StatesModule = {
    states: [FormReportRootState, FormReportState, FormReportViewState],
};

export function registerFormReportStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Form.Report.List, FiStateNames.Form.Report.View], {
        SettingType: [ApplicationSettingsType.FormReports],
        AccessType: AccessRightType.Write,
    });
}
